import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

export interface UpdateItem {
  id: string;
  headline: string;
  text: string;
  link?: { to: string; label: string };
}

interface LatestUpdatesPanelProps {
  title?: string;
  updates?: UpdateItem[];
}

export const DEFAULT_LR_UPDATES: UpdateItem[] = [
  {
    id: "lr-hub-v1",
    headline: "LR Social Hub v1.0 is now live 🎉",
    text: "Check it out — click LR Hub in the navigation and jump into the LaneRunner community. Let's grow the best freight platform together.",
    link: { to: "/social", label: "Open LR Hub" },
  },
];

export function LatestUpdatesPanel({
  title = "Latest LaneRunner Updates",
  updates = DEFAULT_LR_UPDATES,
}: LatestUpdatesPanelProps) {
  return (
    <div className="rounded-lg border bg-warning-subtle p-4 flex flex-col h-full">
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="h-4 w-4 text-brand-teal-deep flex-shrink-0" />
        <h3 className="text-sm font-bold text-foreground uppercase tracking-wide">
          {title}
        </h3>
      </div>

      <ul className="flex flex-col gap-3">
        {updates.map((update) => (
          <li key={update.id} className="flex flex-col gap-1">
            <p className="text-sm font-semibold text-foreground leading-snug">
              {update.headline}
            </p>
            <p className="text-xs text-foreground leading-relaxed">
              {update.text}
            </p>
            {update.link && (
              <Link
                to={update.link.to}
                className="mt-0.5 inline-flex items-center gap-1 text-xs font-semibold text-brand-teal-deep hover:underline w-fit"
              >
                {update.link.label}
                <ArrowRight className="h-3 w-3" />
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
